// extracted by mini-css-extract-plugin
export var closeButton = "_gz-2";
export var closeButtonIcon = "_gz-3";
export var lightboxContent = "_gz-1";
export var lightboxOverlay = "_gz-0";